export type DmAppMessageEnvelope = {
  type: string
  payload?: unknown
}

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null

/** SDK `receive_message`: `{ app_name, data: { type, payload } }`. */
export const parseDmAppMessageEnvelope = (envelope: unknown): DmAppMessageEnvelope | null => {
  if (!isRecord(envelope)) {
    return null
  }

  const data = envelope.data
  if (!isRecord(data)) {
    return null
  }

  return {
    type: data.type as string,
    payload: data.payload
  }
}
